/**
 * PerfProxy class defines the proxy of performance api.
 * Prototype definition comes from 'legacy-js/common/instrumentation/performance-api'.
 * They need to be implemented if we want to replace performance api.
 */
export default class PerfProxy {
  /**
   * Initialize performance api with given value.
   * @param {object} perfApi - The performance api passed from init function.
   */
  constructor(perfApi) {
    this.perfApi = perfApi;
  }

  mark(scenarioName) {
    this.perfApi.mark(scenarioName);
  }

  clearMarks(scenarioName) {
    this.perfApi.clearMarks(scenarioName);
  }

  measure(scenarioName, startMark, endMark) {
    this.perfApi.measure(scenarioName, startMark, endMark);
  }

  clearMeasures(scenarioName) {
    this.perfApi.clearMeasures(scenarioName);
  }
}
